import {
    Content,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge,
    CarouselContainer,
} from './styles';
import { appStoreURL } from '../../constants/urls';
import Carousel from '../Carousel';

const Home = () => {
    return (
        <Content>
            <TextContainer>
                <Title>MoveStack</Title>
                <SubTitle>Every run, ride, and lift. One board.</SubTitle>
                <Description>MoveStack brings your running, cycling, and strength training together. See splits, heart rate zones, routes, and progress trends at a glance. No clutter, no subscription.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" /></a>
            </TextContainer>
            <CarouselContainer>
                <Carousel />
            </CarouselContainer>
        </Content>
    );
}

export default Home;
